import React, { useEffect, useState } from "react";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faSave } from "@fortawesome/free-solid-svg-icons";
import { HOST_URL } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";

const G = "#15803d";

const s = {
    card: {
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 14,
        padding: "28px 32px",
        marginBottom: 20,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    },
    label: {
        fontSize: 11,
        fontWeight: 600,
        color: "#9ca3af",
        letterSpacing: "0.6px",
        textTransform: "uppercase",
        marginBottom: 5,
        display: "block",
    },
    sectionTitle: {
        fontWeight: 700,
        fontSize: 15,
        color: "#111827",
        margin: 0,
    },
    sectionSub: {
        fontSize: 13,
        color: "#9ca3af",
        margin: 0,
    },
    input: {
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: "9px 14px",
        fontSize: 14,
        color: "#111827",
        background: "#fff",
        outline: "none",
        width: "100%",
        transition: "border-color 0.15s",
    },
    btnPrimary: {
        background: G,
        color: "#fff",
        border: "none",
        borderRadius: 8,
        padding: "9px 22px",
        fontSize: 13,
        fontWeight: 500,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 7,
    },
};

const FIELDS = [
    { fieldKey: "consoleDomain", label: "Console Panel Domain", placeholder: "e.g. console.yourdomain.com" },
    { fieldKey: "agentDomain",   label: "Agent Panel Domain",   placeholder: "e.g. agent.yourdomain.com" },
    { fieldKey: "flowDomain",    label: "Flow Domain",          placeholder: "e.g. flow.yourdomain.com" },
];

const ResellerDomainConfigure = () => {
    const [userId] = useState(() => {
        try { return JSON.parse(localStorage.getItem("reseller") || localStorage.getItem("emp") || localStorage.getItem("admin"))?.user?.userId; } catch { return undefined; }
    });
    const [token] = useState(() => {
        try { return JSON.parse(localStorage.getItem("reseller") || localStorage.getItem("emp") || localStorage.getItem("admin"))?.token; } catch { return undefined; }
    });

    const [formData, setFormData] = useState({ consoleDomain: '', agentDomain: '', flowDomain: '' });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [hasRecord, setHasRecord] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const getDomains = async () => {
        setLoading(true);
        try {
            const { data } = await Axios.post(`${HOST_URL}/reseller_domain.php`, {
                user_id: userId,
                method: 'retrieve',
                token,
            });
            if (data.success === true) {
                const d = data.data[0];
                setFormData({
                    consoleDomain: d.console_domain || '',
                    agentDomain: d.agent_domain || '',
                    flowDomain: d.flow_domain || '',
                });
                setHasRecord(true);
            } else {
                setHasRecord(false);
            }
        } catch {
            setHasRecord(false);
        } finally {
            setLoading(false);
        }
    };

    const saveDomains = async () => {
        setSuccessMsg('');
        setErrorMsg('');
        setSaving(true);
        try {
            const { data } = await Axios.post(`${HOST_URL}/reseller_domain.php`, {
                user_id: userId,
                method: hasRecord ? 'update' : 'create',
                token,
                console_domain: formData.consoleDomain,
                agent_domain: formData.agentDomain,
                flow_domain: formData.flowDomain,
            });
            if (data.success === true) {
                setHasRecord(true);
                setSuccessMsg('Domain settings saved successfully.');
            } else {
                setErrorMsg(data.message || 'Failed to save. Please try again.');
            }
        } catch {
            setErrorMsg('Something went wrong. Please try again.');
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => { getDomains(); }, []);

    return (
        <div className="wrapper">
            <AdminLeftMenu />
            <div className="main">
                <AdminHeader />

                <main className="content">
                    <div className="container-fluid p-0">

                        <div style={s.card}>
                            {/* Header */}
                            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
                                <div style={{ width: 42, height: 42, borderRadius: 10, background: "#f0fdf4", border: "1px solid #bbf7d0", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <FontAwesomeIcon icon={faGlobe} style={{ color: G, fontSize: 17 }} />
                                </div>
                                <div>
                                    <p style={s.sectionTitle}>Domain Configuration</p>
                                    <p style={s.sectionSub}>Set custom domains for each reseller panel.</p>
                                </div>
                            </div>

                            {loading ? (
                                <div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: 13 }}>Loading…</div>
                            ) : (
                                <>
                                    <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 10, padding: "20px 24px", display: "flex", flexDirection: "column", gap: 18 }}>
                                        {FIELDS.map(({ fieldKey, label, placeholder }) => (
                                            <div key={fieldKey}>
                                                <label style={s.label}>{label}</label>
                                                <input
                                                    type="text"
                                                    style={s.input}
                                                    placeholder={placeholder}
                                                    value={formData[fieldKey]}
                                                    onChange={e => { const val = e.target.value; setFormData(f => ({ ...f, [fieldKey]: val })); }}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        ))}
                                    </div>

                                    {successMsg && (
                                        <div style={{ marginTop: 14, background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: "10px 16px", color: G, fontSize: 13, fontWeight: 500 }}>
                                            {successMsg}
                                        </div>
                                    )}
                                    {errorMsg && (
                                        <div style={{ marginTop: 14, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 16px", color: "#ef4444", fontSize: 13, fontWeight: 500 }}>
                                            {errorMsg}
                                        </div>
                                    )}

                                    <div style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
                                        <button style={s.btnPrimary} onClick={saveDomains} disabled={saving}>
                                            <FontAwesomeIcon icon={faSave} style={{ fontSize: 12 }} />
                                            {saving ? "Saving…" : "Save Domains"}
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>

                    </div>
                </main>
                <AdminFooter />
            </div>
        </div>
    );
};

export default ResellerDomainConfigure;
